import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
//import { getInstructorIdData } from "../../../lib/classview";
import { getInstructorIdData as getInstructorDataforStudents } from "../../../lib/sessionscheduleview";
import { updateData} from "../../../lib/sessionschedule";

import { getInstructorDatawithClass } from "../../../lib/sessionscheduleview";
import { getInstructorStudentwithClass } from "../../../lib/instructorstudentview";
import { getDataforInstructorActiveStudent } from "../../../lib/classdetailview";
import { useAuth } from "../../../usercontext";
//import { getCurrentDateInput, getCurrentTimeInput } from "../../../generalfunc";
//import moment from "moment";
import ScheduleNote from "./schedulenote";

export default function InstructorScheduleDays() {
  const [instructorId, setInstructorId] = useState();
  const [instructorClass, setInstructorClass] = useState([]);
  const [instructorStudent, setInstructorStudent] = useState([]);
  const [instructorSchedule, setInstructorSchedule] = useState([]);
  const [selectedStudent, setSelectedStudent] = useState();
  const [instructorScheduleDays, setInstructorScheduleDays] = useState([]);
  const [selectedClass, setSelectedClass] = useState("");
  const [period, setPeriod] = useState("OneDate");
  const [sNote, setSNote] = useState("");
  const { profile, setProfile } = useAuth();
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [time, setTime] = useState();
  const [showEndDate, setShowEndDate] = useState(false);
//console.log("instructorScheduleDays",instructorScheduleDays);


async function GetInstructorStudent() {
  const students = await getDataforInstructorActiveStudent(profile.id);
  //console.log("students",students);
  setInstructorSchedule([]);
  setInstructorStudent(students);
  setSelectedStudent(students[0].studentId);
  GetInstructorScheduleData(students[0].studentId)
}

async function GetInstructorScheduleData(studentId) {
  console.log("studentId",studentId);
  console.log("instructor",profile.id);
  
  setSNote("");
  setInstructorSchedule([]);
  if(studentId)
  {
    const sched = await getInstructorDataforStudents(profile.id,studentId);
    setInstructorSchedule(sched);
    console.log("sched",sched);
  }
}


  async function GetInstructorStudentData(classId,instId) {
    setSNote("");
    //console.log("GetInstructorStudentData",classId,instId);
    

    if (classId) {
      const sched = await getInstructorDatawithClass(instId, classId);
      //setInstructorSchedule(sched);
      //console.log("sched", sched);

      const students = await getInstructorStudentwithClass(instId, classId);
      //setInstructorStudent(students);

      //const schdays = await getInstructorDataforSchedule(instId);
      //setInstructorScheduleDays(schdays);
    }

    
  }



  function getStudentStatus(Id, studentId) {
    const result = instructorScheduleDays.filter((days) => {
      return days.scheduleId === Id && days.studentId === studentId;
    });

    //console.log("result",instructorScheduleDays);
    if (result.length > 0) return result[0].status;
    else return "";
  }

  async function ChangeTaskStatus(scheduleId, studentId, status) {
    console.log("ChangeTaskStatus", scheduleId,studentId, status);

    await updateData({
      id: scheduleId,
      status: status,
    });
    GetInstructorScheduleData(selectedStudent);

    /*
    getStudentDayData(scheduleId, studentId).then((data) => {
      if (data.length > 0) {
        updateData([{ ...data[0], status: status }][0]);
      } else {
        addData([
          {
            scheduleId: scheduleId,
            studentId: studentId,
            status: status,
            instructorId: instructorId,
          },
        ]);
      }
    });
    */
    //GetInstructorStudentData(selectedClass,instructorId);
  }

  useEffect(() => {
    GetInstructorScheduleData(selectedStudent);
  }, [selectedStudent]);

  useEffect(() => {
    GetInstructorStudent();
  }, []);

  const essentialheader = (name, buttonname, buttonlink) => {
        return (
          <div className="d-flex pb-1 justify-content-between align-items-center">
            <div>
              <h3>{name}</h3>
              <p></p>
            </div>
            <div className="d-flex">
              <div className="ticket-btn-grp">
                    <Link
                      to={buttonlink}
                    >
                      {buttonname}
                    </Link>
                </div>
              </div>
          </div>
      );
    }
    
  return (
    <div className="col-xl-12 col-md-12 mx-auto">
      <div className="settings-widget profile-details">
        <div className="settings-inner-blk p-2">
          {essentialheader(
            "Instructor Schedule",
            "Schedule New Meeting",
            "/instructor/instructor-addschedule"
            )}
            <div className="row">
              <div className="col-lg-3">
                <div className="form-group">
                  <label className="form-control-label">Student</label>
                  <div className="select-container">
                  <select
                          value={selectedStudent}
                          onChange={(e) => setSelectedStudent(e.target.value)}
                          className="select-box"
                        >
                          {instructorStudent.map(function (data, ix) {
                            return (
                              <option key={ix} value={data.studentId}>
                                {data.studentName + " " + data.studentSurname}
                              </option>
                            );
                          })}
                        </select>

                    <div className="icon-container">
                      <i className="fa-solid fa-chevron-down"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <hr className="mt-2" />
            <div className="comman-space pb-0">
              <div className="settings-referral-blk course-instruct-blk  table-responsive">
                {/* Instructor Users */}
                <table className="table ">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Student</th>
                      <th>Date</th>
                      <th>Time</th>
                      <th>Status</th>                      
                      <th>-</th>
                    </tr>
                  </thead>
                  <tbody>
                    {instructorSchedule.length > 0
                      ? instructorSchedule.map(function (data, ix) { console.log("mapdata",data);
                      
                          return (
                            <>
                              <tr key={data.id}>
                                <td>{data.id}</td>
                                <td>{data.studentname}</td>
                                <td>{data.ldate}</td>
                                <td>{data.ltime.substring(0, 5)}</td>
                                        <td className="mt-4">
                                          <div className="select-container2 mx-2">
                                            <select
                                              value={data.status}
                                              onChange={(e) =>
                                                ChangeTaskStatus(
                                                  data.id,
                                                  data.studentId,
                                                  e.target.value
                                                )
                                              }
                                              className={
                                                data.status === "Absent"
                                                  ? "select-box bg-danger-subtle"
                                                  : data.status === "Late"
                                                  ? "select-box bg-warning-subtle"
                                                  : data.status === "Present"
                                                  ? "select-box bg-success-subtle"
                                                  : "select-box"
                                              }
                                            >
                                              <option
                                                key={0}
                                                value=""
                                                selected={data.status === ""}
                                              >
                                                Select
                                              </option>
                                              <option
                                                key={1}
                                                value="Absent"
                                                selected={data.status === "Absent"}
                                              >
                                                Absent
                                              </option>
                                              <option
                                                key={2}
                                                value="Late"
                                                selected={data.status === "Late"}
                                              >
                                                Late
                                              </option>
                                              <option
                                                key={3}
                                                value="Present"
                                                selected={
                                                  data.status === "Present"
                                                }
                                              >
                                                Present
                                              </option>
                                            </select>
                                          </div>
                                        </td>
                                <td className="text-center">
                                  <button
                                    type="button"
                                    className="btn btn-outline-info"
                                    data-bs-toggle="collapse"
                                    data-bs-target={`#collapseAnswer${ix}`}
                                    aria-expanded="false"
                                    aria-controls={`#collapseAnswer${ix}`}
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="16"
                                      fill="currentColor"
                                      className="bi bi-arrows-angle-expand"
                                      viewBox="0 0 16 16"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        d="M5.828 10.172a.5.5 0 0 0-.707 0l-4.096 4.096V11.5a.5.5 0 0 0-1 0v3.975a.5.5 0 0 0 .5.5H4.5a.5.5 0 0 0 0-1H1.732l4.096-4.096a.5.5 0 0 0 0-.707m4.344-4.344a.5.5 0 0 0 .707 0l4.096-4.096V4.5a.5.5 0 1 0 1 0V.525a.5.5 0 0 0-.5-.5H11.5a.5.5 0 0 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 0 .707"
                                      />
                                    </svg>
                                  </button>
                                </td>
                              </tr>
                              <tr
                                className="collapse"
                                id={`collapseAnswer${ix}`}
                              >
                                <td colSpan={8}>
                                  <ScheduleNote
                                    value={data.note ? data.note : ""}
                                    setValue={setSNote}
                                    scheduleId={data.id}
                                  />
                                </td>
                              </tr>
                            </>
                          );
                        })
                      : ""}
                  </tbody>
                </table>
                {/* Instructor List */}
              </div>
            </div>
          </div>
      </div>
    </div>
  );
}
